<app-horizontal-scroll [reversed]="true">
  <div id="priceEvoContainer" class="price-evolution-container">
    <div>
      <div class="evolution-element" *ngFor="let element of priceEvolutionElements; let i = index"
        [class.red]="element.indicator == '+'"
        [class.green]="element.indicator == '-'"
        [class.gray]="(element.indicator != '+' && element.indicator != '-') || i == 0"
        [class.gold]="element.isBest && i != 0">
        <div class="pe-date">{{getDisplayDate(element.date)}}</div>
        <div class="pe-price">{{getDisplayPrice(element.price)}}</div>
      </div>
    </div>
  </div>
</app-horizontal-scroll>